import { useQuery } from '@tanstack/react-query';

import PriceParrotService from '~/services/PriceParrotService';

import { chainParityQueryKeys } from './chainParityQueryKeys';

export function useGetChainParityCompetitors(
  chainName: string | undefined,
  dateFrom: string | undefined,
  dateTo: string | undefined,
  continent?: string | null,
) {
  return useQuery({
    queryKey: chainParityQueryKeys.competitors(chainName ?? '', dateFrom ?? '', dateTo ?? '', continent ?? null),
    queryFn: async ({ signal }) => {
      if (!chainName || !dateFrom || !dateTo) {
        throw new Error('Chain parity competitors requires chainName, dateFrom, and dateTo');
      }
      const res = await PriceParrotService.getParityTrendChainCompetitors(
        chainName,
        { date_from: dateFrom, date_to: dateTo, continent: continent || undefined },
        signal,
      );
      return res.data;
    },
    enabled: Boolean(chainName && dateFrom && dateTo),
  });
}
